import styled from "styled-components"

export const StyledUsage = styled.div`
  margin-top: 2rem;
`

export const Label = styled.div``

export const SkuLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`
